// Reporting dates are UTC-midnight day keys, not local instants.
const DAY = 86400000;
const dayKey = value => {
  const d = new Date(value);
  return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
};
const todayKey = now => {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Bucharest', year: 'numeric', month: '2-digit', day: '2-digit'
  }).formatToParts(new Date(now));
  const part = name => Number(parts.find(p => p.type === name).value);
  return Date.UTC(part('year'), part('month') - 1, part('day'));
};
const monthStart = value => {
  const d = new Date(value);
  return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1);
};
const previousMonth = value => {
  const d = new Date(value);
  return [Date.UTC(d.getUTCFullYear(), d.getUTCMonth() - 1, 1), monthStart(value) - DAY];
};
const reportPeriod = (period = 'last7days', now = Date.now()) => {
  const today = todayKey(now);
  const yesterday = today - DAY;
  switch (period) {
    case 'yesterday': return [yesterday, yesterday];
    case 'last7days': return [yesterday - 6 * DAY, yesterday];
    case 'last30days': return [yesterday - 29 * DAY, yesterday];
    case 'currentMonth': return [monthStart(yesterday), yesterday];
    case 'lastMonth': return previousMonth(today);
    default: {
      const days = period.split('to');
      if (days.length === 2) return days.map(dayKey);
      return [yesterday - 6 * DAY, yesterday];
    }
  }
};
const referencePeriod = (period = 'last7days', now = Date.now()) => {
  const [start, end] = reportPeriod(period, now);
  if (period === 'lastMonth') return previousMonth(start);
  if (period === 'currentMonth') {
    const previous = previousMonth(start);
    // On the first day, both macros display the last complete month.
    if (new Date(todayKey(now)).getUTCDate() === 1) return previous;
    return [previous[0], Math.min(previous[1], previous[0] + (end - start))];
  }
  const length = Math.round((end - start) / DAY) + 1;
  return [start - length * DAY, start - DAY];
};

export {reportPeriod, referencePeriod};
